<template>
    <div> 
        <v-expansion-panels class="mt-2 " flat tile style="border: 1px solid #ddd;">
            <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate class="ma-0 pa-2">
                    <span class="font-weight-bold text-h6">Plantas</span>
                <template v-slot:actions>
                    <span class="pa-2">Clique para visualizar</span>
                    <v-icon color="pink">
                        mdi-eye
                    </v-icon>
                </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="bordered-table">
                        <tr>
                            <td class="text-left font-weight-bold">
                                Nome
                            </td>
                            <td class="text-left font-weight-bold">
                                Dormitorios
                            </td>
                            <td class="text-left font-weight-bold">
                                Suítes
                            </td>
                            <td class="text-left font-weight-bold">
                                Banheiros
                            </td>
                            <td class="text-left font-weight-bold">
                                Vagas
                            </td>
                            <td class="text-left font-weight-bold">
                                Área
                            </td>
                            <td class="text-left font-weight-bold">
                                Valor Venda
                            </td>
                            <td class="text-left font-weight-bold">
                                Valor Locação
                            </td>
                            <td class="text-left font-weight-bold">
                                Valor Condomínio
                            </td>
                        </tr>
                        <tr v-for="tower in object" :key="tower.id">
                            <td>
                                {{ tower.nome }}
                            </td>
                            <td class="text-center">
                               {{ tower.dormitorios }}
                            </td>
                            <td class="text-center">
                               {{ tower.suites }}
                            </td>
                            <td class="text-center">
                                {{ tower.banheiros }}
                            </td>
                            <td class="text-center">
                                {{ tower.vagas }}
                            </td>
                            <td class="text-center">
                                {{ tower.area }}
                            </td>
                            <td class="text-center">
                                {{ tower.valor_venda | toCurrency }}
                            </td>
                            <td class="text-center">
                                {{ tower.valor_locacao | toCurrency }}
                            </td>
                            <td class="text-center">
                                {{ tower.valor_condominio | toCurrency }}
                            </td>
                        </tr>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>  
        </v-expansion-panels> 
    </div>
</template>

<script>
export default {
    props: {
        object: {
            required: true,
            default: () => ({})
        },
    }, 

    watch: {
        object: {
            handler(newVal) {
                // Atualiza o objeto local se o pai atualizar
                this.item = JSON.parse(JSON.stringify(newVal));
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    computed: {
        me () {
            return this.$store.state.auth.me
        },

        hasData() {
            return this.object && Object.keys(this.object).length > 0;
        }       
    }, 

    data () {
        return {
            
        }
    },
}
</script>

<style scoped>
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.bordered-table th {
  background-color: #f5f5f5;
}
</style>